import { AnalyticsServer } from '@/services/api/analytics-server';

export default {
  state: {
    list: [],
    server: null,
  },
  getters: {
    servers: state => state.list,
    server: state => state.server,
    cpuUsage: state => {
      if (state.server === null) return 0;
      const res = state.server.statuses.system.cpu.cores.reduce((a, usage) => {
        return a + usage;
      }, 0) / state.server.statuses.system.cpu.cores.length;

      return res.toFixed(0);
    },
    memoryUsage: state => {
      return state.server.statuses.system.memory.usage;
    },
  },
  mutations: {
    servers: (state, servers) => { state.list = servers; },
    server: (state, server) => { state.server = server; },
  },
  actions: {
    loadServers (state, params) {
      return AnalyticsServer.load(params)
        .then(resp => {
          state.commit('servers', resp.analytics_servers);
          return resp.analytics_servers;
        });
    },

    showServer (state, id) {
      return AnalyticsServer.show(id)
        .then(resp => {
          state.commit('server', resp.analytics_server);
          return resp.analytics_server;
        });
    },
  },
};
